import type { IconCategory, IconComponentName, IconName } from './types';

export interface IconMetadata {
  name: IconName;
  category: IconCategory;
  categoryLabel: string;
  componentName: IconComponentName;
}

// Icon manifest - maps component names to metadata
export const iconManifest: Record<IconComponentName, IconMetadata> = {
  Anesthesiologist: {
    name: 'anesthesiologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Anesthesiologist',
  },
  Balloons: {
    name: 'balloons',
    category: 'social',
    categoryLabel: 'Social',
    componentName: 'Balloons',
  },
  Calendar: {
    name: 'calendar',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'Calendar',
  },
  CalendarArrowDown: {
    name: 'calendar-arrow-down',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarArrowDown',
  },
  CalendarArrowUp: {
    name: 'calendar-arrow-up',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarArrowUp',
  },
  CalendarCheck: {
    name: 'calendar-check',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarCheck',
  },
  CalendarClock: {
    name: 'calendar-clock',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarClock',
  },
  CalendarCross: {
    name: 'calendar-cross',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarCross',
  },
  CalendarPlus: {
    name: 'calendar-plus',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarPlus',
  },
  CalendarSearch: {
    name: 'calendar-search',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'CalendarSearch',
  },
  Cardiology: {
    name: 'cardiology',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Cardiology',
  },
  Check: {
    name: 'check',
    category: 'status',
    categoryLabel: 'Status',
    componentName: 'Check',
  },
  Check2: {
    name: 'check-2',
    category: 'status',
    categoryLabel: 'Status',
    componentName: 'Check2',
  },
  ChevronDown: {
    name: 'chevron-down',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'ChevronDown',
  },
  ChevronLeft: {
    name: 'chevron-left',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'ChevronLeft',
  },
  ChevronRight: {
    name: 'chevron-right',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'ChevronRight',
  },
  ChevronUp: {
    name: 'chevron-up',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'ChevronUp',
  },
  Clipboard: {
    name: 'clipboard',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Clipboard',
  },
  ClipboardCheck: {
    name: 'clipboard-check',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'ClipboardCheck',
  },
  ClipboardShieldCheck: {
    name: 'clipboard-shield-check',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'ClipboardShieldCheck',
  },
  Clock: {
    name: 'clock',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'Clock',
  },
  ClockForward: {
    name: 'clock-forward',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'ClockForward',
  },
  Cog: { name: 'cog', category: 'data', categoryLabel: 'Data', componentName: 'Cog' },
  CriticalCare: {
    name: 'critical-care',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'CriticalCare',
  },
  Cross: {
    name: 'cross',
    category: 'status',
    categoryLabel: 'Status',
    componentName: 'Cross',
  },
  Cross2: {
    name: 'cross-2',
    category: 'status',
    categoryLabel: 'Status',
    componentName: 'Cross2',
  },
  Cube: {
    name: 'cube',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Cube',
  },
  Database: {
    name: 'database',
    category: 'data',
    categoryLabel: 'Data',
    componentName: 'Database',
  },
  Dentist: {
    name: 'dentist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Dentist',
  },
  Dermatologist: {
    name: 'dermatologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Dermatologist',
  },
  Desktop: {
    name: 'desktop',
    category: 'device',
    categoryLabel: 'Device',
    componentName: 'Desktop',
  },
  Dollar: {
    name: 'dollar',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Dollar',
  },
  Dollar2: {
    name: 'dollar-2',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Dollar2',
  },
  DownArrow: {
    name: 'down-arrow',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'DownArrow',
  },
  Edit: {
    name: 'edit',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Edit',
  },
  EmergencyMedicine: {
    name: 'emergency-medicine',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'EmergencyMedicine',
  },
  Endocrinology: {
    name: 'endocrinology',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Endocrinology',
  },
  Evidence: {
    name: 'evidence',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Evidence',
  },
  LibraryBig: {
    name: 'library-big',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'LibraryBig',
  },
  Ent: {
    name: 'ent',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Ent',
  },
  EntEar: {
    name: 'ent-ear',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'EntEar',
  },
  EntNose: {
    name: 'ent-nose',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'EntNose',
  },
  File: {
    name: 'file',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'File',
  },
  FileCheck: {
    name: 'file-check',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileCheck',
  },
  FileCheck2: {
    name: 'file-check-2',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileCheck2',
  },
  FileClock: {
    name: 'file-clock',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileClock',
  },
  FileCross: {
    name: 'file-cross',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileCross',
  },
  FileEdit: {
    name: 'file-edit',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileEdit',
  },
  FileNote: {
    name: 'file-note',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileNote',
  },
  FilePatient: {
    name: 'file-patient',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FilePatient',
  },
  FilePdf: {
    name: 'file-pdf',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FilePdf',
  },
  FilePlus: {
    name: 'file-plus',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FilePlus',
  },
  FileShare: {
    name: 'file-share',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileShare',
  },
  FileShield: {
    name: 'file-shield',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'FileShield',
  },
  FileSparkle: {
    name: 'file-sparkle',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileSparkle',
  },
  FileStack: {
    name: 'file-stack',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'FileStack',
  },
  Gastroenterologist: {
    name: 'gastroenterologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Gastroenterologist',
  },
  Gastroenterology: {
    name: 'gastroenterology',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Gastroenterology',
  },
  Geriatric: {
    name: 'geriatric',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Geriatric',
  },
  GlobalHealth: {
    name: 'global-health',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'GlobalHealth',
  },
  Gp: { name: 'gp', category: 'medical', categoryLabel: 'Medical', componentName: 'Gp' },
  Gynecologist: {
    name: 'gynecologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Gynecologist',
  },
  Haematologist: {
    name: 'haematologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Haematologist',
  },
  Handshake: {
    name: 'handshake',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Handshake',
  },
  Hepatologist: {
    name: 'hepatologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Hepatologist',
  },
  Hospital: {
    name: 'hospital',
    category: 'building',
    categoryLabel: 'Building',
    componentName: 'Hospital',
  },
  HourGlass: {
    name: 'hour-glass',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'HourGlass',
  },
  Iconslink2: {
    name: 'iconslink-2',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Iconslink2',
  },
  Immunologist: {
    name: 'immunologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Immunologist',
  },
  Infectiologist: {
    name: 'infectiologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Infectiologist',
  },
  Infinite: {
    name: 'infinite',
    category: 'status',
    categoryLabel: 'Status',
    componentName: 'Infinite',
  },
  Internist: {
    name: 'internist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Internist',
  },
  Leadership: {
    name: 'leadership',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Leadership',
  },
  LeftArrow: {
    name: 'left-arrow',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'LeftArrow',
  },
  LightBulb: {
    name: 'light-bulb',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'LightBulb',
  },
  Link: {
    name: 'link',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Link',
  },
  Link3: {
    name: 'link-3',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Link3',
  },
  Lock: {
    name: 'lock',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'Lock',
  },
  MedicalCross: {
    name: 'medical-cross',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'MedicalCross',
  },
  MensHealth: {
    name: 'mens-health',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'MensHealth',
  },
  MentalHealth: {
    name: 'mental-health',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'MentalHealth',
  },
  Message: {
    name: 'message',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Message',
  },
  Microphone: {
    name: 'microphone',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Microphone',
  },
  Microscope: {
    name: 'microscope',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Microscope',
  },
  MobilePhone: {
    name: 'mobile-phone',
    category: 'device',
    categoryLabel: 'Device',
    componentName: 'MobilePhone',
  },
  Navigation: {
    name: 'navigation',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'Navigation',
  },
  Neonatologist: {
    name: 'neonatologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Neonatologist',
  },
  Nephrologist: {
    name: 'nephrologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Nephrologist',
  },
  Neurology: {
    name: 'neurology',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Neurology',
  },
  NoNotification: {
    name: 'no-notification',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'NoNotification',
  },
  Notification: {
    name: 'notification',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Notification',
  },
  Nurse: {
    name: 'nurse',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Nurse',
  },
  Obgyn: {
    name: 'obgyn',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Obgyn',
  },
  Oncologist: {
    name: 'oncologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Oncologist',
  },
  OpenLock: {
    name: 'open-lock',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'OpenLock',
  },
  Ophthalmologist: {
    name: 'ophthalmologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Ophthalmologist',
  },
  Optometrist: {
    name: 'optometrist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Optometrist',
  },
  OrthopaedistSpine: {
    name: 'orthopaedist-spine',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'OrthopaedistSpine',
  },
  Orthopedist: {
    name: 'orthopedist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Orthopedist',
  },
  Paediatrician: {
    name: 'paediatrician',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Paediatrician',
  },
  PaperPlane: {
    name: 'paper-plane',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'PaperPlane',
  },
  Parasitologist: {
    name: 'parasitologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Parasitologist',
  },
  Pathologist: {
    name: 'pathologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Pathologist',
  },
  Patient: {
    name: 'patient',
    category: 'user',
    categoryLabel: 'User',
    componentName: 'Patient',
  },
  Pen: {
    name: 'pen',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'Pen',
  },
  PenSparkle: {
    name: 'pen-sparkle',
    category: 'files-forms-editing',
    categoryLabel: 'Files/Forms/Editing',
    componentName: 'PenSparkle',
  },
  Phone: {
    name: 'phone',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Phone',
  },
  Podiatrist: {
    name: 'podiatrist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Podiatrist',
  },
  Pulmonologist: {
    name: 'pulmonologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Pulmonologist',
  },
  Radiologist: {
    name: 'radiologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Radiologist',
  },
  Refresh: {
    name: 'refresh',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'Refresh',
  },
  RightArrow: {
    name: 'right-arrow',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'RightArrow',
  },
  Routines: {
    name: 'routines',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Routines',
  },
  RulerBlock: {
    name: 'ruler-block',
    category: 'tools',
    categoryLabel: 'Tools',
    componentName: 'RulerBlock',
  },
  Search: {
    name: 'search',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'Search',
  },
  SearchCode: {
    name: 'search-code',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'SearchCode',
  },
  SearchProfile: {
    name: 'search-profile',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'SearchProfile',
  },
  Shield: {
    name: 'shield',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'Shield',
  },
  ShieldCheck: {
    name: 'shield-check',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'ShieldCheck',
  },
  ShieldPlus: {
    name: 'shield-plus',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'ShieldPlus',
  },
  ShieldUser: {
    name: 'shield-user',
    category: 'compliance-safety',
    categoryLabel: 'Compliance / Safety',
    componentName: 'ShieldUser',
  },
  Star: {
    name: 'star',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'Star',
  },
  Target: {
    name: 'target',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Target',
  },
  TextSearch: {
    name: 'text-search',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'TextSearch',
  },
  Team: {
    name: 'team',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Team',
  },
  TierEnterpriseFilled: {
    name: 'tier-enterprise-filled',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierEnterpriseFilled',
  },
  TierEnterpriseOutline: {
    name: 'tier-enterprise-outline',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierEnterpriseOutline',
  },
  TierFreeFilled: {
    name: 'tier-free-filled',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierFreeFilled',
  },
  TierFreeOutline: {
    name: 'tier-free-outline',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierFreeOutline',
  },
  TierPracticeFilled: {
    name: 'tier-practice-filled',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierPracticeFilled',
  },
  TierPracticeOutline: {
    name: 'tier-practice-outline',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierPracticeOutline',
  },
  TierProFilled: {
    name: 'tier-pro-filled',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierProFilled',
  },
  TierProOutline: {
    name: 'tier-pro-outline',
    category: 'tier',
    categoryLabel: 'Tier',
    componentName: 'TierProOutline',
  },
  Timer: {
    name: 'timer',
    category: 'time-calendar',
    categoryLabel: 'Time / Calendar',
    componentName: 'Timer',
  },
  TrendDown: {
    name: 'trend-down',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'TrendDown',
  },
  TrendDown2: {
    name: 'trend-down-2',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'TrendDown2',
  },
  TrendUp: {
    name: 'trend-up',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'TrendUp',
  },
  TrendUp2: {
    name: 'trend-up-2',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'TrendUp2',
  },
  Trophy: {
    name: 'trophy',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'Trophy',
  },
  UpArrow: {
    name: 'up-arrow',
    category: 'navigation',
    categoryLabel: 'Navigation',
    componentName: 'UpArrow',
  },
  Urologist: {
    name: 'urologist',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Urologist',
  },
  User: { name: 'user', category: 'user', categoryLabel: 'User', componentName: 'User' },
  UserGroup: {
    name: 'user-group',
    category: 'user',
    categoryLabel: 'User',
    componentName: 'UserGroup',
  },
  Vet: {
    name: 'vet',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'Vet',
  },
  Video: {
    name: 'video',
    category: 'product',
    categoryLabel: 'Product',
    componentName: 'Video',
  },
  Wifi: { name: 'wifi', category: 'wifi', categoryLabel: 'Wifi', componentName: 'Wifi' },
  Wifi2: {
    name: 'wifi-2',
    category: 'wifi',
    categoryLabel: 'Wifi',
    componentName: 'Wifi2',
  },
  WomensHealth: {
    name: 'womens-health',
    category: 'medical',
    categoryLabel: 'Medical',
    componentName: 'WomensHealth',
  },
  WorldwideExpand: {
    name: 'worldwide-expand',
    category: 'business',
    categoryLabel: 'Business',
    componentName: 'WorldwideExpand',
  },
};

// Icons grouped by category
export const iconsByCategory: Record<IconCategory, IconName[]> = {
  building: ['hospital'],
  business: [
    'dollar',
    'dollar-2',
    'handshake',
    'leadership',
    'light-bulb',
    'paper-plane',
    'target',
    'team',
    'trend-down',
    'trend-down-2',
    'trend-up',
    'trend-up-2',
    'trophy',
    'worldwide-expand',
  ],
  'compliance-safety': [
    'clipboard-shield-check',
    'file-shield',
    'lock',
    'open-lock',
    'shield',
    'shield-check',
    'shield-plus',
    'shield-user',
  ],
  data: ['cog', 'database'],
  device: ['desktop', 'mobile-phone'],
  'files-forms-editing': [
    'clipboard',
    'clipboard-check',
    'edit',
    'file',
    'file-check',
    'file-check-2',
    'file-clock',
    'file-cross',
    'file-edit',
    'file-note',
    'file-patient',
    'file-pdf',
    'file-plus',
    'file-share',
    'file-sparkle',
    'file-stack',
    'iconslink-2',
    'link',
    'link-3',
    'pen',
    'pen-sparkle',
  ],
  medical: [
    'anesthesiologist',
    'cardiology',
    'critical-care',
    'dentist',
    'dermatologist',
    'emergency-medicine',
    'endocrinology',
    'ent',
    'ent-ear',
    'ent-nose',
    'gastroenterologist',
    'gastroenterology',
    'geriatric',
    'global-health',
    'gp',
    'gynecologist',
    'haematologist',
    'hepatologist',
    'immunologist',
    'infectiologist',
    'internist',
    'medical-cross',
    'mens-health',
    'mental-health',
    'neonatologist',
    'nephrologist',
    'neurology',
    'nurse',
    'obgyn',
    'oncologist',
    'ophthalmologist',
    'optometrist',
    'orthopaedist-spine',
    'orthopedist',
    'paediatrician',
    'parasitologist',
    'pathologist',
    'podiatrist',
    'pulmonologist',
    'radiologist',
    'urologist',
    'vet',
    'womens-health',
  ],
  navigation: [
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'down-arrow',
    'left-arrow',
    'navigation',
    'refresh',
    'right-arrow',
    'search',
    'star',
    'up-arrow',
  ],
  product: [
    'cube',
    'evidence',
    'library-big',
    'message',
    'microphone',
    'microscope',
    'no-notification',
    'notification',
    'phone',
    'routines',
    'search-code',
    'search-profile',
    'text-search',
    'video',
  ],
  social: ['balloons'],
  status: ['check', 'check-2', 'cross', 'cross-2', 'infinite'],
  tier: [
    'tier-enterprise-filled',
    'tier-enterprise-outline',
    'tier-free-filled',
    'tier-free-outline',
    'tier-practice-filled',
    'tier-practice-outline',
    'tier-pro-filled',
    'tier-pro-outline',
  ],
  'time-calendar': [
    'calendar',
    'calendar-arrow-down',
    'calendar-arrow-up',
    'calendar-check',
    'calendar-clock',
    'calendar-cross',
    'calendar-plus',
    'calendar-search',
    'clock',
    'clock-forward',
    'hour-glass',
    'timer',
  ],
  tools: ['ruler-block'],
  user: ['patient', 'user', 'user-group'],
  wifi: ['wifi', 'wifi-2'],
};

// Get icon metadata by component name
export function getIconMetadata(
  componentName: IconComponentName
): IconMetadata | undefined {
  return iconManifest[componentName];
}

// Get icons by category
export function getIconsByCategory(category: IconCategory): IconName[] {
  return iconsByCategory[category] || [];
}

// Get all icon names (kebab-case)
export function getAllIconNames(): IconName[] {
  return Object.values(iconManifest).map((icon) => icon.name);
}

// Get all icon component names (PascalCase)
export function getAllIconComponentNames(): IconComponentName[] {
  return Object.keys(iconManifest) as IconComponentName[];
}

// Get all categories
export function getAllCategories(): IconCategory[] {
  return Object.keys(iconsByCategory) as IconCategory[];
}
